import React, { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { Event } from 'services/api';
import { CheckInTabs } from './CheckInTabs';
import { EmailRosterTab } from './EmailRosterTab';
import { EventCodeTab } from './EventCodeTab';
import { ScanTab } from './ScanTab';
import { OrganizerTab } from './types';

interface OrganizerCheckInProps {
  event: Event;
  onClose: () => void;
}

export const OrganizerCheckIn: React.FC<OrganizerCheckInProps> = ({
  event,
  onClose,
}) => {
  const storageKey = `event-check-in-tab:${event.id}`;
  const [tab, setTab] = useState<OrganizerTab>(() => {
    if (typeof window === 'undefined') return 'scan';
    const stored = window.sessionStorage.getItem(storageKey);
    if (stored === 'scan' || stored === 'email' || stored === 'eventCode') {
      return stored;
    }
    return 'scan';
  });

  const handleTabChange = (id: OrganizerTab) => {
    setTab(id);
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(storageKey, id);
    }
  };

  const tabs = useMemo(
    () => [
      { id: 'scan', label: 'Scan' },
      { id: 'email', label: 'Email' },
      { id: 'eventCode', label: 'Event Code' },
    ],
    [],
  );

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CheckInTabs
        tabs={tabs}
        activeId={tab}
        onChange={id => handleTabChange(id as OrganizerTab)}
      />
      {tab === 'scan' && (
        <ScanTab
          eventId={event.id}
          method="staff_scan"
          showScanNext
          onClose={onClose}
        />
      )}
      {tab === 'email' && <EmailRosterTab eventId={event.id} />}
      {tab === 'eventCode' && <EventCodeTab event={event} />}
    </Box>
  );
};
